import React from 'react';
import PropTypes from 'prop-types';

import Text from '../../components/Text/Text';

const Breadcrumbs = ({ breadcrumbs, containerStyle }) => {
  const { pageTitle, history } = breadcrumbs;

  return (
    <div className="breadcrumbs">
      <div className={`py-[20px] ${containerStyle || ''}`}>
        <div><Text text={pageTitle} bold textStyle="text-[17px]" /></div>
        <div className="flex flex-row items-center">
          {history.map(({ title, onClick }, index) => (
            <div
              key={title}
              className={`flex flex-row items-center ${onClick ? 'hover:cursor-pointer hover:text-primary' : ''}`}
              onClick={onClick}
              role="presentation"
            >
              <>
                <Text
                  text={title}
                  muted
                  textStyle={`text-[12px] capitalize ${onClick ? 'hover:text-primary' : ''}`}
                />
                {(index < history.length - 1) && <div className="w-[5px] h-[2px] bg-text-muted mx-[8px]" />}
              </>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.shape({
    pageTitle: PropTypes.string.isRequired,
    history: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      onClick: PropTypes.func
    }))
  }).isRequired,
  containerStyle: PropTypes.string
};

Breadcrumbs.defaultProps = {
  containerStyle: undefined
};

export default Breadcrumbs;
